import { Component, OnInit } from '@angular/core';
import { DataService } from '../../data.service';
import { ActivatedRoute,Router } from '@angular/router';




@Component({
  selector: 'app-bill',
  templateUrl: './bill.component.html',
  styleUrls: ['./bill.component.scss']
})
export class BillComponent implements OnInit {

  constructor(private router:Router, private route: ActivatedRoute, private dataService: DataService) { }

  bill:any = {
    status:0
  };
  id:any = 0;
  
  paymentModes:any = [
	"",
	"Cash",
	"Card",
	"Cheque",
	"UPI"
  ];
  selectedPaymentMode:any = 1;
  therapists:any = [];
  selectedTherapist:any = 0;
  printer:any = "";

  ngOnInit() {
    this.id = (this.route.snapshot.paramMap.get('id') != null) ? this.route.snapshot.paramMap.get('id') : 0;
    this.loadBill();
	this.loadTherapists();
	this.loadPaymentModes();

	//Connect QZTray
	//@ts-ignore
	qz.websocket.connect().then(function() {
		console.log("Printer connected!");
	});

  }

  loadBill(){
    this.dataService.getSingleBill(this.id).subscribe( (data:any = {data:{}} )=> {
		this.bill = data.data;
		this.printer = data.printer;
		});
  }

  loadTherapists(){
    this.dataService.getTherapists().subscribe( (data: any = {status:0} )=> {
      if(data.status == 0){
        this.therapists = data;
      }
      
      
    });
  }

  printBill(){
		var bill = this.bill;
		var imgData = "data:image/jpeg;base64,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";
		//@ts-ignore
		var doc = new jsPDF();
		
    
    /**************************** 
    Client copy;
    ****************************/


		var y = 5;
		doc.addImage(imgData, 'JPEG', 85,y,42.5,26);
		doc.setFontSize(8);

		
		y+=27;
		doc.text(40, y, "National Institute of Physical Medicine and Rehabilitation(NIPMR), Kallettumkara P.O, Thrissur – 680683");
		y+=5;
		
		doc.text(60, y, "Phone: 0480-288-1959, +91 7510870111, Email: nipmrin@gmail.com");
		y+=10;

		if(bill.patient_id != 0){

		
			doc.setFontType('bold');
			doc.text(10, y, "Patient: ");
			doc.setFontType('normal');
			doc.text(12+doc.getTextWidth("Patient: "), y, bill.patient + " (" + bill.reg_no + ")");

			doc.setFontType('bold');
			doc.text(150, y, "Consultant: ");
			doc.setFontType('normal');
			doc.text(152+doc.getTextWidth("Consultant: "), y,bill.consultant)
			y+=5;
		}	
		
		if(bill.patient_id != 0){
			doc.setFontType('bold');
			var xage = 10;
			doc.text(xage, y, "Age: ");
			xage += 2+doc.getTextWidth("Age: ");
			doc.setFontType('normal');
			doc.text(xage, y, bill.age.toString());
			doc.setFontType('bold');
			xage += doc.getTextWidth(bill.age.toString())+2;
			doc.text(xage, y, "Gender: ");
			xage += doc.getTextWidth("Gender: ");
			doc.setFontType('normal');
			doc.text(xage, y, bill.gender);
		}

		if(bill.patient_id == 0){
			doc.setFontType('bold');
			doc.text(10, y+5, "Payer: ");
			doc.setFontType('normal');
			doc.text(12+doc.getTextWidth("Payer: "), y+5, bill.payer);
			y+=5;
		}

		doc.setFontType('bold');
		doc.text(150, y, "Mode of Payment: ");
		doc.setFontType('normal');
		doc.text(152+doc.getTextWidth("Mode of Payment: "), y, bill.payment_mode);
		doc.setFontType('bold');


		y+=5;
		doc.setFontType('bold');
		doc.text(10, y, "Bill No.: ");
		doc.setFontType('normal');
		doc.text(12+doc.getTextWidth("Bill No.: "), y, bill.bill_no.toString() );
		
		
		doc.setFontType('bold');
		doc.text(150, y, "Bill Date: ");
		doc.setFontType('normal');
		doc.text(152+doc.getTextWidth("Bill Date: "), y, bill.bill_date );


		doc.setFontType('bold');
		y+=10;
		doc.text(10, y, 'Sl No.');
		doc.text(20, y, 'Particulars');
		doc.text(150, y, 'Rate', 'right');
		doc.text(170, y, 'Quantity', 'right');
		doc.text(190, y, 'Amount', 'right');
		doc.setFontType('normal');
		var i = 1;
		y+=10;

		//contents
		$.each(bill.contents, function(key, index){
			doc.text(10, y, i.toString());
			doc.text(20, y, this.description);
      		//doc.line(20+doc.getTextWidth(this.description)+5, y-1, 136,y-1);
      		doc.line(60, y-1, 136,y-1);
			doc.text(150, y, this.rate, 'right');
			doc.text(170, y, this.qty.toString(), 'right');
			doc.text(190, y, this.amount, 'right');
			i++;
			

			if(this.dates.length > 0){
				y += 3;
				doc.setFontSize(7);
				doc.text(20, y, this.dates);	
				doc.setFontSize(8);
				y+=5;
			} else {
				y += 5;
			}

		});
		y +=5


		//print total
		doc.setFontType('bold');
		doc.text(20, y, "Total Amount: ");
		doc.text(190, y, bill.total, 'right');
		if(parseInt(bill.discount) > 0 ) {
		y+=5;
		doc.text(20, y, "Discount: ");
		doc.text(190, y, bill.discount, 'right');
		y+=5;
		doc.text(20, y, "Payable: ");
		doc.text(190, y, bill.payable, 'right');
		}
    

		y+=20;
		doc.text(10, y, "Amount chargeable (in words)");
		y+=5;
		doc.setFontSize(9);
		doc.setFontType('bold');
		//@ts-ignore
		doc.text(10, y, "Indian Rupees "+number2words(bill.payable)+" Only (INR " +bill.payable.toString() + ")"  );
		doc.setFontType('normal');
		doc.line(180,140, 180+doc.getTextWidth("Signature"), 140);
		doc.text(180, 145, "Signature");
    
    doc.line(0,148.5,210,148.5);
    doc.setFontType('normal');
    
    /**************************** 
    Office copy;
    ****************************/
    
    y = 153;
    doc.addImage(imgData, 'JPEG', 85,y,42.5,26);
		doc.setFontSize(8);

		
		y+=27;
		doc.text(40, y, "National Institute of Physical Medicine and Rehabilitation(NIPMR), Kallettumkara P.O, Thrissur – 680683");
		y+=5;
		
		doc.text(60, y, "Phone: 0480-288-1959, +91 7510870111, Email: nipmrin@gmail.com");

		y+=10;
		if(bill.patient_id != 0){

		
			doc.setFontType('bold');
			doc.text(10, y, "Patient: ");
			doc.setFontType('normal');
			doc.text(12+doc.getTextWidth("Patient: "), y, bill.patient + " (" + bill.reg_no + ")");

			doc.setFontType('bold');
			doc.text(150, y, "Consultant: ");
			doc.setFontType('normal');
			doc.text(152+doc.getTextWidth("Consultant: "), y,bill.consultant)
			y+=5;
		}	
		
		if(bill.patient_id != 0){
			doc.setFontType('bold');
			var xage = 10;
			doc.text(xage, y, "Age: ");
			xage += 2+doc.getTextWidth("Age: ");
			doc.setFontType('normal');
			doc.text(xage, y, bill.age.toString());
			doc.setFontType('bold');
			xage += doc.getTextWidth(bill.age.toString())+2;
			doc.text(xage, y, "Gender: ");
			xage += doc.getTextWidth("Gender: ");
			doc.setFontType('normal');
			doc.text(xage, y, bill.gender);
		}

		if(bill.patient_id == 0){
			doc.setFontType('bold');
			doc.text(10, y+5, "Payer: ");
			doc.setFontType('normal');
			doc.text(12+doc.getTextWidth("Payer: "), y+5, bill.payer);
			y+=5;
		}

		doc.setFontType('bold');
		doc.text(150, y, "Mode of Payment: ");
		doc.setFontType('normal');
		doc.text(152+doc.getTextWidth("Mode of Payment: "), y, bill.payment_mode);
		doc.setFontType('bold');


		y+=5;
		doc.setFontType('bold');
		doc.text(10, y, "Bill No.: ");
		doc.setFontType('normal');
		doc.text(12+doc.getTextWidth("Bill No.: "), y, bill.bill_no.toString() );
		
		
		doc.setFontType('bold');
		doc.text(150, y, "Bill Date: ");
		doc.setFontType('normal');
		doc.text(152+doc.getTextWidth("Bill Date: "), y, bill.bill_date );
		
		


		doc.setFontType('bold');
		y+=10;
		doc.text(10, y, 'Sl No.');
		doc.text(20, y, 'Particulars');
		doc.text(150, y, 'Rate', 'right');
		doc.text(170, y, 'Quantity', 'right');
		doc.text(190, y, 'Amount', 'right');
		doc.setFontType('normal');
		var i = 1;
		y+=10;

		//contents
		$.each(bill.contents, function(key, index){
			doc.text(10, y, i.toString());
			doc.text(20, y, this.description);
      		//doc.line(20+doc.getTextWidth(this.description)+5, y-1, 136,y-1);
      		doc.line(60, y-1, 136,y-1);
			doc.text(150, y, this.rate, 'right');
			doc.text(170, y, this.qty.toString(), 'right');
			doc.text(190, y, this.amount, 'right');
			i++;
			
			if(this.dates.length > 0){
				y += 3;
				doc.setFontSize(7);
				doc.text(20, y, this.dates);	
				doc.setFontSize(8);
				y+=5;
			} else {
				y += 5;
			}

		});
		y +=5


		//print total
		doc.setFontType('bold');
		/*doc.text(170, y, "Total Amount: ", 'right');
		doc.text(190, y, bill.total, 'right');
		if(parseInt(bill.discount) > 0 ) {
		y+=5;
		doc.text(170, y, "Discount: ", 'right');
		doc.text(190, y, bill.discount, 'right');
		y+=5;
		doc.text(170, y, "Payable: ", 'right');
		doc.text(190, y, bill.payable, 'right');
		}*/
		doc.text(20, y, "Total Amount: ");
		doc.text(190, y, bill.total, 'right');
		if(parseInt(bill.discount) > 0 ) {
		y+=5;
		doc.text(20, y, "Discount: ");
		doc.text(190, y, bill.discount, 'right');
		y+=5;
		doc.text(20, y, "Payable: ");
		doc.text(190, y, bill.payable, 'right');
		}
    

		y+=20;
		doc.text(10, y, "Amount chargeable (in words)");
		y+=5;
		doc.setFontSize(9);
		doc.setFontType('bold');
		//@ts-ignore
		doc.text(10, y, "Indian Rupees "+number2words(bill.payable)+" Only (INR " +bill.payable.toString() + ")"  );

		doc.setFontType('normal');
		doc.line(180,289, 180+doc.getTextWidth("Signature"), 289);
		doc.text(180, 294, "Signature");



		//Labels

		doc.text(10, 145, "CLIENT COPY");
		doc.text(10, 294, "OFFICE COPY");

		//output
		var string = doc.output('datauristring');
		var newWindow = window.open("", "PDF", 'dependent=yes,locationbar=no,scrollbars=no,menubar=no,resizable,screenX=50,screenY=50,width=850,height=800');
		newWindow.document.write(
		'<html><body><center>' +
		
		'</center><br>' +
		'<object width=100% height=100% type="application/pdf" data="'+string+'">' +
		'<embed type="application/pdf" src="'+string+'" id="embed_pdf"></embed>' +
		'</object></body></html>');
		newWindow.window.focus();
	}

	submitPm(data){
		data.bill_id = this.id;
		data.field = "payment_mode";
		this.dataService.postUpdateBill(data).subscribe( (res:any) => {
			if(res.status == 0) {
			$("#modal-edit-pm").modal('hide');
			  this.loadBill();
			} else {
			  alert(res.msg);
			}
	
		  }); 

	}

	submitCons(data){
		data.bill_id = this.id;
		data.field = "consultant_id";
		this.dataService.postUpdateBill(data).subscribe( (res:any) => {
			if(res.status == 0) {
			$("#modal-edit-cons").modal('hide');
			  this.loadBill();
			} else {
			  alert(res.msg);
			}
	
		  }); 

	}

	loadPaymentModes(){
		this.dataService.getPaymentModes().subscribe( (data: any = {status:0} )=> {
		  this.paymentModes = data;
		});
	}

	submitBillCancel(data) {
		//@ts-ignore
		data.bill_id = this.id;

		this.dataService.postCancelBill(data).subscribe( (res:any) => {

		if(res.status == 0) {
		  alert(res.msg);
		  $('#modal-cancel-bill').modal('hide');
		  
		  this.loadBill();
		} else {
		  alert(res.msg);
		}

	  } ); 


	}

	printBillDM(){
		var content = "";
		//Bill header
		for(var i=0; i<1; i++){ content += " " }; //Add space to center-align text
		content += "National Institute of Physical Medicine and Rehabilitation(NIPMR) ".toUpperCase() + "\r\n";
		for(var i=0; i<16; i++){ content += " " };
		content += " Kallettumkara P.O, Thrissur - 680683" + "\r\n";
		for(var i=0; i<16; i++){ content += " " };
		content += "Phone: 0480-288-1959, +91 7510870111"  + "\r\n";
		for(var i=0; i<21; i++){ content += " " };
		content += "Email: nipmrin@gmail.com" + "\r\n";
		for(var i=0; i<67; i++){ content += "-" };
		content += "\r\n";

		

		//Patient Info
		if(this.bill.patient_id != 0){
			content += " Patient: " + this.bill.patient + "("+this.bill.reg_no+")" + "\r\n";
			content += " Age: " + this.bill.age.toString() + "   Gender: " + this.bill.gender;
			var ag = " Age: " + this.bill.age.toString() + "   Gender: " + this.bill.gender;
			for(var i=0; i< 44 - ag.length  ; i++){ content += " " };
			content += "Mode of payment: " + this.bill.payment_mode + "\r\n";
			content += " Bill No.: " + this.bill.bill_no.toString(); 
			var bn = " Bill No.: " + this.bill.bill_no.toString();
			for(var i=0; i< 44 - bn.length; i++){ content += " " };
			content += "Bill Date:" + this.bill.bill_date;
			
		}
		//Payer info
		if(this.bill.patient_id == 0){
			content += " Payer: " + this.bill.payer;
			var payerText = " Payer: " + this.bill.payer;
			for(var i=0; i< 44 - payerText.length  ; i++){ content += " " };
			content += "Mode of payment: " + this.bill.payment_mode + "\r\n";
			content += " Bill No.: " + this.bill.bill_no.toString(); 
			var bn = " Bill No.: " + this.bill.bill_no.toString();
			for(var i=0; i< 44 - bn.length; i++){ content += " " };
			content += "Bill Date:" + this.bill.bill_date;
		}

		//Code for bills against non-patients;

		content += "\r\n";
		content += "\r\n";

		//Items header

		content += " NO. PARTICULARS                         RATE      QTY    AMOUNT" + "\r\n" ;

		//Loop through billcontents
		var slno = 1;
		this.bill.contents.forEach(bc => {

			let desc = "";
			let desc2 = "";
			if(bc.description.length > 32){
				desc = bc.description.slice(0,32);
				desc2 = bc.description.split(desc).pop();
				desc += "-";
			} else {
				desc = bc.description;
			}

			content += " "+ slno; //Sl No.
			for(var i=0; i< 4-slno.toString().length; i++){ content += " " };
			content += desc;
			for(var i=0; i< 36 - desc.length; i++){ content += " " };
			content += bc.rate;
			for(var i=0; i< 10 - bc.rate.length; i++){ content += " " };
			content += bc.qty;
			console.log(bc.qty.toString().length);
			for(var i=0; i< 7 - bc.qty.toString().length; i++){ content += " " };
			content += bc.amount;
			content += "\r\n";

			if(desc2.length > 0){
				for(var i=0; i< 6-slno.toString().length; i++){ content += " " };
				content += desc2;
				content += "\r\n";
			}

			slno ++;
		});
		
		content += "\r\n";
		//Total amount;
		

		var tstring = "Total Amount: " + this.bill.total;
		for(var i=0; i< 64 - tstring.length; i++){ content += " " };
		content += "Total Amount: " + this.bill.total + "\r\n"; 
		if(parseInt(this.bill.discount) > 0 ) {

			var dstring = "Discount: " + this.bill.discount;
			var pstring = "Payable: " + this.bill.payable; 
			for(var i=0; i< 64 - dstring.length; i++){ content += " " };
			content += "Discount: " + this.bill.discount + "\r\n"; 
			for(var i=0; i< 64 - pstring.length; i++){ content += " " };
			content += "Payable: " + this.bill.payable + "\r\n"; 
		}

		content += "\r\n\r\n\r\n";
		var signature = "Signature";
		for(var i=0; i< 64 - signature.length; i++){ content += " " };
		content += signature;
		content += "\r\n\r\n\r\n\r\n";
		content += "\r\n\r\n\r\n";
		content += "\r\n\r\n\r\n\r\n";
		content += "\r\n\r\n\r\n";
		content += ".";

		//Output
		
		
		
		
		//content = content.toUpperCase();

		
		/*
	    var blob = new Blob([content], {type: "text/plain", endings: "transparent"});
		//@ts-ignore
	    window.saveAs(blob, "bill.txt"); 
		*/
		
		//QZ-Tray

		var printer = this.printer;
		console.log(printer);
		//var printer = "PDF";
		var data = [
			content
			
		];
		//@ts-ignore
		var config = qz.configs.create(printer);
		//@ts-ignore
		qz.print(config, data).catch(function(e) { console.error(e); });
		

	}

}
